import styled from '../../../../theme'
import { IWithSize } from '../../../BookingCalendar/Calendar/Calendar'

const SafariWrapper = styled.div<IWithSize>`
  min-height: 568px;
  min-height: calc(var(--full) - ${({ size }) => (size ? 110 * size : 110)}px);
`

export default SafariWrapper
